import SearchModel from'./SearchModel';
class AddressModel {
    id              = -1
    region          = ""
    ato             = ""
    np              = ""
    street          = ""
    buiding         = ""
    flat            = ""
    descAddress    = ""
    infoAddress     = ""
    
    searchModel = null;
}

export default AddressModel